"use client";

import QuestionLayout from "@/app/layout/question";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";

import CruiseCoverModal from "./components/cruise-cover-modal/cruise-cover-modal";
import DescriptionContent from "./components/description-section";
import FormContent from "./components/form-content";
import useCruiseHooks from "./hooks/cruise.hooks";
import { useCruiseContext } from "./provider/cruise.provider";

function Cruise() {
  const {
    selectedAnswer,
    isOpenUnsavedChangesModal,
    setIsOpenUnsavedChangesModal,
    handleUnSavedWarningMessageContinueBtn,
    magnoliaData,
    scrollRefArray,
    isCruiseModalOpen,
  } = useCruiseContext();
  const {
    loading,
    isFooterLoading,
    isHideFooterBack,
    handleSubmit,
    handleBackButton,
    handleCruiseCoverModalConfirmButton,
    handleCruiseCoverModalBackButton,
    isLastStepInCoverEditQuoteSummary,
  } = useCruiseHooks();
  const { backToRenewalsText, ctaButtonText, finishEditingBtnText } =
    magnoliaData.overlayArea[0];
  const { current } = useWizard();
  return (
    <>
      {isCruiseModalOpen && (
        <CruiseCoverModal
          handleCruiseCoverModalConfirmButton={
            handleCruiseCoverModalConfirmButton
          }
          handleCruiseCoverModalBackButton={handleCruiseCoverModalBackButton}
        />
      )}
      <QuestionLayout
        formSection={<FormContent />}
        descriptionContent={<DescriptionContent />}
        footer={{
          isHideFooterBack,
          isLoading: loading || isFooterLoading,
          isDisabledBack: false,
          isDisabledContinue: selectedAnswer === 0,
          footerActionBack: () => {
            handleBackButton();
          },
          footerActionContinue: () => {
            handleSubmit();
          },
          id: "cruise",
          brand: "staysure",
          ctaButtonText: isLastStepInCoverEditQuoteSummary
            ? finishEditingBtnText
            : ctaButtonText ?? "Continue",
        }}
        progressBarPercent={current.progressBarPercentage ?? 22.5}
        backToRenewalSection={{
          isOpenUnsavedChangesModal,
          backToRenewalText: backToRenewalsText ?? "Back to Renewal",
          onContinueClick: handleUnSavedWarningMessageContinueBtn,
          setIsOpenUnsavedChangesModal,
        }}
        scrollRefs={scrollRefArray}
      />
    </>
  );
}

export default Cruise;
